module.exports = __webpack_public_path__ + "static/media/STPLong1w522@2x.06fcd92c.webp";